import { schema } from "normalizr";
import pageSchema from "./page";
import segmentSchema from "./segment";

const pointSchema = new schema.Entity(
    "points",
    {
        pageId: pageSchema,
        segmentIds: [segmentSchema]
    },
    {
        idAttribute: "id"
    }
);

export default pointSchema;



// WEBPACK FOOTER //
// ./src/schemas/point.js